//导入sha1验证
import { Sha1, hex_sha1 } from "./sha1";

//获取签名结果
function getSign(params) {
    //本项目的随机字符串
    let noncestr = "8e919e7980a2eb2ed8e1d4230f25508f";
    params["noncestr"] = noncestr;

    //获取时间戳
    let timestamp = Date.parse(new Date()) / 1000;
    params["timestamp"] = timestamp;

    let keys = Object.keys(params).sort();
    let newParams = {};
    keys.forEach(key => {
        newParams[key] = params[key];
    });
    let signStr = "";
    Object.keys(newParams).forEach((key, index) => {
        let values = newParams[key] + "";
        if (values.length > 0) {
            signStr += key + "=" + values + "&";
        }
    });
    let signature = hex_sha1(signStr.substring(0, signStr.lastIndexOf("&")));
    return {
        signature: signature,
        timestamp: timestamp,
    };
}

export { getSign };
